import axiosInstance from "auth/FetchInterceptor";
import {
  PROVINCE_BY_COUNTRY,
  WARD_BY_PROVINCE,
  GET_COUNTRY_API,
  ALL_WARD,
} from "constants/ApiConstant";
const LocationService = {};

LocationService.getCountry = function () {
  return axiosInstance.get(GET_COUNTRY_API, null);
};

LocationService.provinceByCountry = function (id) {
  return axiosInstance.get(`${PROVINCE_BY_COUNTRY}/${id}`, null);
};

LocationService.wardByProvince = function (id) {
  return axiosInstance.get(`${WARD_BY_PROVINCE}/${id}`, null);
};

LocationService.getAllWard = function (data) {
  return axiosInstance.post(ALL_WARD, data);
};

export default LocationService;